import { makeAutoObservable } from 'mobx';

class InventoryAddEditState {
  constructor(initialData) {
    this.state = initialData;
    makeAutoObservable(this);
  }

  state = null;

  setState(key, value) {
    this.error = null;
    this.state[key] = value;
  }
}

export default InventoryAddEditState;
